import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-view"},[_c(VTabsItems,{attrs:{"value":_vm.activeTabIndex}},_vm._l((_vm.tabs),function(tab,index){return _c(VTabItem,{key:tab.id},[_vm._t("default",null,{"tab":Object.assign({}, tab, {isActive: index === _vm.activeTabIndex})})],2)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }